'use strict';
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/web.set-interval');
require('../modules/web.set-timeout');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/web.timers.js
// module id = 975
// module chunks = 0